import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "../../store";
import { Contact, ContactLink } from "../../types/ContactTypes";
import { contactsApi } from "../services/contacts";
import { authApi } from "../services/auth";

type ContactsState = {
  list: Contact[] | [];
  contactLink: ContactLink | undefined;
};

const initialState: ContactsState = {
  list: [],
  contactLink: undefined,
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        contactsApi.endpoints.getContacts.matchFulfilled,
        (state, { payload }) => {
          state.list = payload.results;
        }
      )
      .addMatcher(
        contactsApi.endpoints.getContactLink.matchFulfilled,
        (state, { payload }) => {
          state.contactLink = payload;
        }
      )
      .addMatcher(
        contactsApi.endpoints.acceptContactLink.matchFulfilled,
        (state) => {
          state.contactLink = undefined;
        }
      )
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state) => {
        state.contactLink = undefined;
      })
      .addMatcher(authApi.endpoints.signup.matchFulfilled, (state) => {
        state.contactLink = undefined;
      });
  },
});

export default contactsSlice.reducer;

export const selectContacts = (state: RootState) => state.contacts.list;
export const selectContactLink = (state: RootState) =>
  state.contacts.contactLink;
